export default __webpack_public_path__ + "7f00d0d.png";